import React from "react";
import PropTypes from "prop-types";

import ReactTable from "react-table";
import Loading from "../../common/Loading";

import { CALL_DETAIL_COLUMNS } from "./columns";

const CustomerBalanceSummaryList = ({
  data,
  loading,
  onPageSizeChange,
  defaultPageSize,
  onPageChange,
  onSortedChange,
  page,
  sorted,
  pages,
  pageSize
}) => {
  if (loading)
    return (
      <div className="loading">
        <Loading />
      </div>
    );

  return data && data.length ? (
    <div className="content-wrapper">
      <ReactTable
        showPageSizeOptions
        showPagination
        className="-highlight calls"
        columns={CALL_DETAIL_COLUMNS}
        data={data}
        defaultPageSize={defaultPageSize}
        noDataText="No contracts found"
        pageSize={Math.min(pageSize)}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        manual
        pages={pages}
        sorted={sorted}
        page={page}
        onSortedChange={onSortedChange}
      />
    </div>
  ) : (
    <div className="loading">
      <h4 style={{ opacity: 0.15 }}>No Data</h4>
    </div>
  );
};
CustomerBalanceSummaryList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  defaultPageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onPageSizeChange: PropTypes.func,
  onPageChange: PropTypes.func,
  onSortedChange: PropTypes.func,
  page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sorted: PropTypes.array,
  pages: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  pageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default CustomerBalanceSummaryList;
